import httpInstances from '@/api/axiosInstance';

/**
 * Downloads a text-based file (e.g., CSV) from the datalake by name and group.
 * Returns the file content as string.
 */
export const downloadTextFileFromDatalake = async (fileName: string, groupName: string) => {
  const response = await httpInstances.axiosInternalInstance.get(
    `/proxy/datalake/file?fileName=${encodeURIComponent(fileName)}&groupName=${encodeURIComponent(groupName)}`,
    { responseType: 'text' as any }
  );
  if (response.status === 200) {
    // Axios with responseType 'text' may put the text into response.data directly
    return typeof response.data === 'string' ? response.data : String(response.data);
  }
  throw new Error('File not found');
};

export default downloadTextFileFromDatalake;
